var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "a-popover",
    {
      attrs: {
        placement: "bottomLeft",
        trigger: "click",
        overlayClassName: _vm.popoverClass + " modern-custom-popover",
      },
      model: {
        value: _vm.popoverVisible,
        callback: function ($$v) {
          _vm.popoverVisible = $$v
        },
        expression: "popoverVisible",
      },
    },
    [
      _c("template", { slot: "content" }, [
        _c(
          "div",
          { staticClass: "modern-custom-dropdown" },
          [
            _vm._t("content"),
            _vm._v(" "),
            _vm.showFormFooter
              ? _c("div", { staticClass: "popover-actions" }, [
                  _c(
                    "button",
                    {
                      staticClass: "action-btn clear-btn",
                      on: { click: _vm.onClear },
                    },
                    [_vm._v("Temizle")]
                  ),
                  _vm._v(" "),
                  _c(
                    "button",
                    {
                      staticClass: "action-btn apply-btn",
                      on: { click: _vm.onApply },
                    },
                    [_vm._v("Uygula")]
                  ),
                ])
              : _vm._e(),
          ],
          2
        ),
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "modern-custom-trigger", class: _vm.triggerClass },
        [
          _vm._t("trigger", function () {
            return [
              _c(
                "div",
                { staticClass: "select-button", class: _vm.buttonClass },
                [
                  _vm.showIcon && _vm.icon
                    ? _c("i", { staticClass: "material-icons button-icon" }, [
                        _vm._v(_vm._s(_vm.icon)),
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _c("span", { staticClass: "button-text" }, [
                    _vm._v(_vm._s(_vm.label)),
                  ]),
                  _vm._v(" "),
                  _vm.removable
                    ? _c(
                        "i",
                        {
                          staticClass: "material-icons chip-remove-inline",
                          on: {
                            click: function ($event) {
                              $event.stopPropagation()
                              return _vm.onRemoveClick.apply(null, arguments)
                            },
                          },
                        },
                        [_vm._v("close")]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.clearable && !_vm.removable
                    ? _c(
                        "i",
                        {
                          staticClass: "material-icons chip-clear-inline",
                          on: {
                            click: function ($event) {
                              $event.stopPropagation()
                              return _vm.onClearClick.apply(null, arguments)
                            },
                          },
                        },
                        [_vm._v("delete_forever")]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.showDropdownArrow
                    ? _c(
                        "i",
                        { staticClass: "material-icons dropdown-arrow" },
                        [_vm._v("keyboard_arrow_down")]
                      )
                    : _vm._e(),
                ]
              ),
            ]
          }),
        ],
        2
      ),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }